import React from 'react';
import { string, func, bool, oneOf, node } from 'prop-types';
import Skeleton from '@mui/material/Skeleton';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import { Row, SectionHeader, Body, Column, Colors, LabelText, H3 } from '../..';
import { EmptyViewWrapper, SkeletonWrapperText, SkeletonWrapperIcons } from './EditableContentBlock.styles';
import { ClickableArea } from '../Buttons/ClickableArea';
export const EditableContentBlock = _ref => {
  let {
    content,
    triggerModal,
    isEditable,
    title,
    subtitle,
    heading,
    skeletonLoaderType
  } = _ref;
  const onClick = isEditable ? triggerModal : () => {};
  if (content && isEditable) {
    return /*#__PURE__*/React.createElement(ClickableArea, {
      sx: {
        padding: '16px',
        width: '100%'
      },
      onClick: onClick
    }, /*#__PURE__*/React.createElement(Column, {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(SectionHeader, null, /*#__PURE__*/React.createElement(Row, {
      style: {
        justifyContent: 'space-between'
      }
    }, /*#__PURE__*/React.createElement("span", null, heading), isEditable && /*#__PURE__*/React.createElement(EditSharpIcon, null))), /*#__PURE__*/React.createElement(Body, {
      as: "div",
      style: {
        margin: 0
      }
    }, content)));
  }
  if (content && !isEditable) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(SectionHeader, null, heading), /*#__PURE__*/React.createElement(Body, {
      as: "div",
      style: {
        margin: 0
      }
    }, content));
  }
  if (!content && isEditable) {
    return /*#__PURE__*/React.createElement(EmptyViewWrapper, {
      "data-test-id": "empty-view",
      onClick: onClick,
      style: {
        color: Colors.plum_electric
      }
    }, /*#__PURE__*/React.createElement(H3, null, title), /*#__PURE__*/React.createElement(LabelText, null, subtitle), skeletonLoaderType === 'text' && /*#__PURE__*/React.createElement(SkeletonWrapperText, null, /*#__PURE__*/React.createElement(Skeleton, {
      animation: false,
      height: 36
    }), /*#__PURE__*/React.createElement(Skeleton, {
      animation: false,
      width: "60%",
      height: 36
    })), skeletonLoaderType === 'icon' && /*#__PURE__*/React.createElement(SkeletonWrapperIcons, null, /*#__PURE__*/React.createElement(Skeleton, {
      variant: "circular",
      animation: false,
      width: 36,
      height: 36
    }), /*#__PURE__*/React.createElement(Skeleton, {
      variant: "circular",
      animation: false,
      width: 36,
      height: 36
    }), /*#__PURE__*/React.createElement(Skeleton, {
      variant: "circular",
      animation: false,
      width: 36,
      height: 36
    }), /*#__PURE__*/React.createElement(Skeleton, {
      variant: "circular",
      animation: false,
      width: 36,
      height: 36
    })));
  }
  return null;
};
EditableContentBlock.propTypes = {
  content: node,
  title: string.isRequired,
  subtitle: string,
  triggerModal: func,
  isEditable: bool.isRequired,
  heading: string.isRequired,
  skeletonLoaderType: oneOf(['text', 'icon'])
};
EditableContentBlock.defaultProps = {
  content: null,
  subtitle: '',
  triggerModal: () => {},
  skeletonLoaderType: 'text'
};